module.exports = __webpack_public_path__ + "static/media/demo.e2168904.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/demo.gif
 ** module id = 162
 ** module chunks = 0
 **/